import { Card, Typography } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  foot?: ReactNode;
  tone?: 'bad' | 'warn' | 'ok';
}

/**
 * Small KPI card used across every dashboard-style screen.
 * Value is monospace (numbers reconcile — U-02); tone changes colour only, never meaning.
 */
export function KpiCard({ label, value, foot, tone }: Props) {
  const valueColor = tone === 'bad' ? '#8e2e28' : tone === 'warn' ? '#7d5610' : tone === 'ok' ? '#1c6442' : '#14213d';
  return (
    <Card size="small">
      <div style={{ fontSize: 10.5, letterSpacing: 0.4, textTransform: 'uppercase', color: '#8a94a6', fontWeight: 600 }}>
        {label}
      </div>
      <div style={{ fontSize: 22, fontWeight: 600, fontFamily: "'JetBrains Mono', ui-monospace, monospace", color: valueColor, marginTop: 4 }}>
        {value}
      </div>
      {foot && <Typography.Text type="secondary" style={{ fontSize: 11.5 }}>{foot}</Typography.Text>}
    </Card>
  );
}
